import { httpsCallable } from "firebase/functions";
import { functions } from "../config/firebase";
export async function getOrganizations() {
    const getOrgs = httpsCallable(functions, "listUserRepositories");
    const result = await getOrgs();
    return result.data;
}
export async function setUnityCloudApiKey(org, key) {
    const setKey = httpsCallable(functions, "setUnityApiKey");
    const result = await setKey({ org: org.name, key: key });
    return result.data;
}
export async function getMockOrganizations() {
    return new Promise((resolve, _) => {
        const orgInfo = [
            {
                name: "example",
                avatar: "https://via.placeholder.com/150",
                apiKey: "asdsadad",
            },
            {
                name: "example number two",
                avatar: "https://via.placeholder.com/100",
            },
        ];
        resolve({ message: orgInfo, code: 200 });
    });
}
